<!-- 签字扫描件弹窗 -->
<template>
    <custom-modal
        width="800px"
        title="工资发放核准结果"
        :visible="visible"
        class="confirm-modal"
        @on-close="handleClose"
    >
        <div class="steps-info">
            <p><b>工资月：</b>{{ commonParams.attendanceMonthDesc }}</p>
            <p><b>核准确认状态：</b><span class="status">{{ detail.bankFlowApprovalStateText }}</span></p>
        </div>
        <a-tabs
            v-model="activeKey"
        >
            <a-tab-pane v-for="item in tabList"
                        :key="item.key"
                        :tab="`${item.tab}${item.num ? `（${item.num}）` : ''}`" />
        </a-tabs>
        <custom-table
            row-key="id"
            size="middle"
            :pagination="false"
            :scroll="scrollConfig"
            :columns="columns"
            :data-source="dataList"
        >
            <template #action="_, data">
                <a-button type="link" @click="handleAddReason(data)">原因说明</a-button>
            </template>
        </custom-table>
        <template v-if="detail.bankFlowApprovalState === APPROVAL_STATE_NOT_APPROVED"  slot="customFooter">
            <a-popconfirm
                ok-text="确认"
                cancel-text="取消"
                :loading="loading"
                @confirm="handleCancel">
                <a-icon v-show="false" slot="icon" />
                <template slot="title">
                    <p>是否确认操作取消核准，操作成功后，核准结果数据将被删除</p>
                </template>
                <a-button :loading="loading">
                    取消核准
                </a-button>
            </a-popconfirm>
            <a-popconfirm
                ok-text="确认"
                cancel-text="取消"
                :loading="loading"
                @confirm="handleOk">
                <a-icon v-show="tabList[1].num || tabList[2].num"
                        slot="icon"
                        type="warning"
                        theme="filled"
                        style="color: red; font-size: 18px; margin-top: -3px;" />
                <template slot="title">
                    <p>{{ popconfirmTitle }}</p>
                </template>
                <a-button type="primary" :loading="loading">
                    确认核准结果
                </a-button>
            </a-popconfirm>
        </template>
        <template v-else slot="customFooter">
            <div />
        </template>
        <reason-modal ref="reasonModalRef" @on-refresh="reload" />
    </custom-modal>
</template>

<script>
import {
    Button as AButton,
    Tabs as ATabs,
    Popconfirm as APopconfirm,
    Icon as AIcon
} from 'ant-design-vue'
import CustomModal from '@components/CustomModal'
import CustomTable from '@components/CustomTable'
import initTable from '@mixins/initTable'
import ReasonModal from './ReasonModal'
import { APPROVAL_STATE_NOT_APPROVED } from '@/constant/enum'

import { SALARY_CONFIRM_SUC_LIST_COLUMNS, SALARY_CONFIRM_FAIL_LIST_COLUMNS, BANK_UNCONFIRM_LIST_COLUMNS } from './config'
import { getSalaryBankFlowReconciliationPage, cancelSalaryBankFlowReconciliation, confirmSalaryBankFlowReconciliation, getSalaryBankFlowReconciliationRecordPage } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'ConfirmModal',
    components: {
        AButton,
        CustomModal,
        CustomTable,
        ATabs,
        ATabPane: ATabs.TabPane,
        APopconfirm,
        ReasonModal,
        AIcon
    },
    mixins: [initTable],
    props: {
        record: {
            type: Object,
            required: true
        },
        detail: {
            type: Object,
            default: () => ({})
        },
        commonParams: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            APPROVAL_STATE_NOT_APPROVED,
            visible: false,
            tabNumList: [0, 0, 0],
            activeKey: '1',
            scrollConfig: Object.freeze({
                x: 800,
                y: 500
            })
        }
    },
    computed: {
        tabList() {
            return [
                {
                    key: '1',
                    tab: '核准成功',
                    num: this.tabNumList?.[0] || 0,
                    columns: SALARY_CONFIRM_SUC_LIST_COLUMNS
                },
                {
                    key: '2',
                    tab: '核准异常',
                    num: this.tabNumList?.[1] || 0,
                    columns: this.detail.bankFlowApprovalState === APPROVAL_STATE_NOT_APPROVED ? SALARY_CONFIRM_FAIL_LIST_COLUMNS : SALARY_CONFIRM_FAIL_LIST_COLUMNS.slice(0, -1)
                },
                {
                    key: '3',
                    tab: '流水未匹配',
                    num: this.tabNumList?.[2] || 0,
                    columns: this.detail.bankFlowApprovalState === APPROVAL_STATE_NOT_APPROVED ? BANK_UNCONFIRM_LIST_COLUMNS : BANK_UNCONFIRM_LIST_COLUMNS.slice(0, -1)
                }
            ]
        },
        columns() {
            return this.tabList.find(item => item.key === this.activeKey).columns
        },
        popconfirmTitle() {
            if (this.tabList[1].num || this.tabList[2].num) {
                return '存在核准异常数据，是否确认核准结果，确认后无法被修改'
            }
            return '操作成功后，核准结果将无法被修改，是否确认核准结果'
        },
        pageApi() {
            return this.detail?.bankFlowApprovalState === APPROVAL_STATE_NOT_APPROVED ? getSalaryBankFlowReconciliationPage : getSalaryBankFlowReconciliationRecordPage
        }
    },
    watch: {
        activeKey: {
            handler() {
                this.getList()
            },
            immediate: false
        },
        visible: {
            handler(val) {
                if (val) {
                    this.activeKey = '1'
                    this.getList()
                    this.getNumber()
                }
            }
        }
    },
    methods: {
        reload() {
            this.getList()
        },
        handleAddReason(data) {
            this.$refs.reasonModalRef.open(data)
        },
        handleClose() {
            this.visible = false
        },
        async handleCancel() {
            this.loading = true
            try {
                await cancelSalaryBankFlowReconciliation({
                    projectCode: this.commonParams.projectCode,
                    monthDesc: this.commonParams.attendanceMonthDesc,
                    operationNumber: this.detail.operationNumber
                })
                this.$emit('on-refresh')
                this.$message.success('取消成功！')
                this.handleClose()
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        async handleOk() {
            this.loading = true
            try {
                await confirmSalaryBankFlowReconciliation({
                    projectCode: this.commonParams.projectCode,
                    monthDesc: this.commonParams.attendanceMonthDesc,
                    operationNumber: this.detail.operationNumber
                })
                this.$emit('on-refresh')
                this.$message.success('确认成功！')
                this.handleClose()
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },
        open() {
            this.visible = true
        },
        async getNumber() {
            if (!this.visible) return
            try {
                this.loading = true
                this.tabList.forEach(async (item, index) => {
                    this.tabNumList[index] = Number((await this.pageApi({
                        queryType: item.key, // 查询类型状态（1：核准成功，2：核准异常，3：工资表未匹配）,示例值(1)
                        projectCode: this.commonParams.projectCode,
                        monthDesc: this.commonParams.attendanceMonthDesc,
                        ...this.params
                    }))?.total)
                    this.tabNumList = [...this.tabNumList]
                })
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        },

        // 获取分页列表数据
        async getList() {
            if (!this.visible) return
            try {
                this.loading = true

                const result = await this.pageApi({
                    queryType: this.activeKey, // 查询类型状态（1：核准成功，2：核准异常，3：工资表未匹配）,示例值(1)
                    projectCode: this.commonParams.projectCode,
                    monthDesc: this.commonParams.attendanceMonthDesc,
                    ...this.params
                })

                this.total = result.total || 0
                this.dataList = result.records || []
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss">
    .confirm-modal {
        .steps-info {
            display: flex;

            p {
                margin-right: 16px;

                .status {
                    color: red;
                }
            }
        }
    }
</style>
